import { Link } from "react-router-dom";
import { useNovels } from "../Novels";
import { Loading } from "../../components/Loading";
import { Logo } from "../../components/Logo";
import { AnchorHTMLAttributes, HTMLAttributes } from "react";
import { Belt } from "../../components/Belt";

import "./index.scss";
import { useTitle } from "../../utils/useTitle";
import { RecentReading } from "../../components/RecentReading";

const Header = () => {
  return (
    <Belt className="Header">
      <Link to={{ pathname: "/" }}>
        <Logo />
      </Link>
      <div>精神力研究协会</div>
    </Belt>
  );
};

const Pixiv = (props: AnchorHTMLAttributes<HTMLAnchorElement>) => {
  return (
    <a
      href="https://www.pixiv.net/novel/series/8729514"
      target="_blank"
      rel="noreferrer"
      {...props}
    >
      <svg
        width="41"
        height="16"
        viewBox="0 0 82 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M30.83 0c.596 0 1.092.199 1.489.596.397.396.596.893.596 1.488s-.2 1.092-.596 1.488c-.397.397-.893.596-1.488.596-.596 0-1.092-.199-1.49-.596-.396-.396-.594-.893-.594-1.488s.198-1.092.595-1.488C29.739.199 30.235 0 30.83 0zm-3.835 17.933a9.573 9.573 0 00-3.317-7.293c-2.1-1.834-5.04-2.893-8.459-2.893-8.908 0-14.967 6.871-14.967 6.871l1.707 2.708s.945.08.445-1.516c.431-.815 1.277-1.913 2.927-3.18v18.04c-.711.201-1.652.578-1.01 1.22h4.904c.648-.648-.372-1.038-.994-1.22v-4.255s3.363 1.319 6.988 1.319c3.186 0 6.084-.947 8.24-2.658 2.155-1.7 3.544-4.24 3.536-7.143zm-3.58-.046c-.008 2.348-.845 4.282-2.336 5.765-1.49 1.471-3.658 2.401-6.159 2.4-2.79 0-5.138-.539-6.688-1.302V11.215c1.7-1.208 4.46-1.952 6.688-1.947 2.707.002 4.833 1.024 6.27 2.575 1.435 1.561 2.219 3.634 2.226 6.044zm7.918-10.14c.443 0 .803.36.803.803V27c0 .444-.36.803-.803.803h-.999a.803.803 0 01-.803-.803V8.55c0-.443.36-.803.803-.803h1zm26.91.803a.804.804 0 00-.803-.803h-1a.803.803 0 00-.802.803V27c0 .443.359.803.803.803h.999c.443 0 .803-.36.803-.803V8.55zm22.682-.803c.684 0 1.053.304.667 1.078-.308.62-6.069 11.93-8.362 16.434l-.931 1.828c-.235.443-.663.716-1.125.716-.462 0-.89-.273-1.125-.716 0 0-8.908-17.488-9.295-18.262-.385-.774-.016-1.078.668-1.078h.93c.73 0 .931.095 1.26.754.327.656 7.562 14.99 7.562 14.99s7.234-14.334 7.561-14.99c.329-.66.53-.754 1.26-.754h.93zM43.883 19.903l5.668 7.23c.377.48.648.67 1.378.67h1.498c.936 0 .615-.423.35-.773l-.006-.007c-.665-.877-7.231-9.224-7.231-9.224s6.802-8.394 7.468-9.272l.005-.008c.266-.35.586-.772-.35-.772h-1.497c-.73 0-1.002.19-1.379.671-.377.48-5.904 7.276-5.904 7.276s-5.532-6.796-5.909-7.276c-.376-.481-.648-.67-1.377-.67h-1.498c-.936 0-.616.421-.35.771l.005.008c.666.878 7.473 9.272 7.473 9.272s-6.764 8.347-7.43 9.224l-.006.008c-.265.35-.585.772.35.772h1.498c.73 0 1-.19 1.378-.67.377-.481 5.866-7.23 5.866-7.23zM58.427.596C58.029.199 57.533 0 56.937 0c-.595 0-1.09.199-1.487.596-.398.396-.596.893-.596 1.488s.199 1.092.596 1.488c.396.397.892.596 1.487.596.596 0 1.092-.199 1.49-.596.396-.396.595-.893.595-1.488S58.823.992 58.427.596z"
          fill="#0096FA"
        />
      </svg>
    </a>
  );
};

const Footer = ({ ...rest }: HTMLAttributes<HTMLDivElement>) => {
  return (
    <Belt className="Footer" {...rest}>
      <span>日更连载中，首发于</span>
      <Pixiv style={{ marginLeft: ".5ch" }} />
    </Belt>
  );
};

const List = () => {
  const novels = useNovels();
  if (!novels) return <Loading />;

  return (
    <ol>
      {novels.map(({ number, title, size }) => {
        return (
          <li key={number}>
            <span className="title">
              <Link to={String(number)}>
                #{number} {title}
              </Link>
              <RecentReading number={number} />
            </span>
            <span className="size">（{size} 字）</span>
          </li>
        );
      })}
    </ol>
  );
};

export const NovelsList = () => {
  useTitle("目录");
  return (
    <div className="NovelsList">
      <Header />
      <List />
      <Footer />
    </div>
  );
};
